import React from "react";

const barColor = (v) =>
  v >= 0.85 ? "hsl(var(--destructive))" :
  v >= 0.7  ? "hsl(var(--warning))" :
  v >= 0.5  ? "hsl(var(--primary))" :
              "hsl(217 91% 60%)";

export const ContributingFactors = ({ factors = [] }) => {
  return (
    <div className="panel p-3 min-w-0" data-testid="contributing-factors">
      <div className="h-widget mb-2">Contributing Factors</div>
      <div className="space-y-2">
        {factors.map((f) => {
          const pct = Math.round(f.value * 100);
          const contribution = Math.round(f.value * f.weight * 100);
          return (
            <div key={f.id} data-testid={`factor-${f.id}`}>
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="font-display font-bold text-[11px] uppercase tracking-tight">{f.label}</span>
                <span className="font-mono text-[10px] text-muted-foreground">w {Math.round(f.weight * 100)}%</span>
                <span className="ml-auto font-mono text-xs">
                  <span style={{ color: barColor(f.value) }}>{pct}</span>
                  <span className="text-muted-foreground"> · +{contribution} pts</span>
                </span>
              </div>
              <div className="mt-1 h-1.5 bg-border w-full">
                <div className="h-full transition-all" style={{ width: `${pct}%`, background: barColor(f.value) }} />
              </div>
              {f.detail && (
                <div className="font-mono text-[10px] text-muted-foreground mt-0.5">{f.detail}</div>
              )}
            </div>
          );
        })}
        {factors.length === 0 && (
          <div className="text-xs text-muted-foreground">Loading factors…</div>
        )}
      </div>
    </div>
  );
};

export default ContributingFactors;
